import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LeaveTypeList = Loadable(lazy(() => import("./LeaveTypeList")));
const LeaveTypeAdd = Loadable(lazy(() => import("./LeaveTypeAdd")));

const LeaveTypeRoutes = [
  { path: "/ems/leave/types", element: <LeaveTypeList /> },
  { path: "/ems/leave/types/:mode/:id", element: <LeaveTypeAdd /> },
];

export default LeaveTypeRoutes;
